import React, {useEffect, useState} from 'react';
import Input from '../Input';
import CustomSelect from '../CustomSelect';
import Checkbox from '../Checkbox';
import {
  useChangeCorrectiveActionMutation,
  useGetCorrectiveActionQuery,
} from '../../store/builder/inspections.api';
import {toast} from 'react-toastify';
import {useDispatch, useSelector} from 'react-redux';
import {setFields, setLoader} from '../../store/builder/reducer';
import {useErrorHandler} from '../../global/ErrorsHandler';
import {useNavigate} from 'react-router-dom';
import moment from 'moment';
import ViewImageModal from './ViewImageModal';
import {useTranslation} from '../../hooks/useTranslation';

export default function CorrectiveActionModal({ exit, action, currentTab, onSuccess }) {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const loader = useSelector(state => state?.rootReducer?.reducer?.loader);
  const [image, setImage] = useState(null);
  const [activeImage, setActiveImage] = useState(null);
  const [images, setImages] = useState([]);
  const [viewModalStatus, setViewModalStatus] = useState(false);
  const [selectedSimilarCorrectives, setSelectedSimilarCorrectives] = useState([]);

  const [changeData, setChangeData] = useState({
    id: action.id,
    action: '',
    discrepancy: '',
    repair_time: '',
  });
  const [
    changeAction,
    {
      data: changeActionData,
      isError: changeActionIsError,
      isLoading: changeActionIsLoading,
      isSuccess: changeActionIsSuccess,
      error: changeActionError,
    },
  ] = useChangeCorrectiveActionMutation();

  const {
    data: correctiveRaw,
    isLoading: correctiveIsLoading,
    error: correctiveError,
    isSuccess: correctiveIsSuccess,
  } = useGetCorrectiveActionQuery(action?.id, {
    skip: !action?.id,
  });

  // Prefer API payload if present; fall back to prop `action`
  const correctiveAction = correctiveRaw?.data ?? correctiveRaw ?? action;

  const [errorHandler, setErrorHandler] = useErrorHandler([changeActionError, correctiveError]);

  useEffect(() => {
    if (changeActionIsLoading) {
      dispatch(setLoader(true));
    }
    if (changeActionIsSuccess) {
      dispatch(setLoader(false));
      toast.success(changeActionData.message);
      exit();
    }
  }, [changeActionIsSuccess, changeActionIsLoading,]);

  useEffect(() => {
    if (correctiveIsLoading) {
      dispatch(setLoader(true));
    }
    if (correctiveIsSuccess) {
      dispatch(setLoader(false));
    }
  }, [correctiveIsSuccess, correctiveIsLoading,]);

  useEffect(() => {
    dispatch(setFields(correctiveAction?.old_result?.field));
  }, [loader, correctiveAction]);
  useEffect(() => {
    if (correctiveAction?.discrepancy) {
      setChangeData(old => ({...old, discrepancy: correctiveAction?.discrepancy}));
    }
  }, [correctiveAction]);
  const handleChange = e => {
    setChangeData(old => ({...old, [e.target.name]: e.target.value}));
  };
  const closeAction = () => {
    if (changeData.action.length > 1 && changeData.discrepancy.length > 1) {
      let form = new FormData();
      form.append('id', changeData.id);
      form.append('discrepancy', changeData.discrepancy);
      form.append('action', changeData.action);
      form.append('repair_time', changeData.repair_time);
      selectedSimilarCorrectives.forEach(id => {
        form.append('close_similar_corrective_ids[]', id);
      });

      if (action?.millipore_required) {
        // if (!image?.data) {
        //   toast.error('Please upload millipore test file!')
        // } else {
        //   if (Object?.values(image?.data)?.length > 0) {
        //     for (let i = 0; i < Object?.values(image?.data)?.length; i++) {
        //       form.append(`images[${i}]`, Object?.values(image?.data)[i])
        //     }
        //   }
        changeAction(form).then(() => {
          if (onSuccess) {
            onSuccess();
          }
        });
        // }
      } else {
        if (image?.data) {
          if (Object?.values(image?.data)?.length > 0) {
            for (let i = 0; i < Object?.values(image?.data)?.length; i++) {
              form.append(`images[${i}]`, Object?.values(image?.data)[i]);
            }
          }
        }
        changeAction(form).then(() => {
          if (onSuccess) {
            onSuccess();
          }
        });
      }
    } else {
      toast.error(t('correctiveActionModal.messages.fillAllFields'));
    }
  };

  const handleImage = e => {
    const selectedFiles = e.target.files;
    const selectedFilesArray = Array?.from(selectedFiles);
    const imagesArray = selectedFilesArray.map(file => {
      return URL.createObjectURL(file);
    });
    setImage({preview: imagesArray, data: e.target.files});
  };

  const clickImage = v => {
    setActiveImage(v);
    setViewModalStatus(true);
    setImages(() => image?.preview);
  };

  const handleSelectAllSimilar = (e) => {
    if (e.target.checked) {
      const allIds = correctiveAction?.similar_correctives?.map(item => item.id) || [];
      setSelectedSimilarCorrectives(allIds);
    } else {
      setSelectedSimilarCorrectives([]);
    }
  };

  const handleSelectSimilar = (id) => {
    setSelectedSimilarCorrectives(prev => {
      if (prev.includes(id)) {
        return prev.filter(itemId => itemId !== id);
      } else {
        return [...prev, id];
      }
    });
  };

  const isAllSelected = correctiveAction?.similar_correctives?.length > 0 && 
    selectedSimilarCorrectives.length === correctiveAction?.similar_correctives?.length;

  return (
    <div className='modal'>
      {viewModalStatus && (
        <ViewImageModal
          exit={() => setViewModalStatus(false)}
          activeImage={activeImage}
          images={images}
          setActiveImage={setActiveImage}
        />
      )}
      <div className='modal__content'>
        <div className='modal__content-head'>
          <p>{t('correctiveActionModal.title')}</p>
          <img
            className='modal__content-exit'
            src='/assets/icons/close.svg'
            alt='close'
            onClick={exit}
          />
        </div>
        <div className='modal__content-body corrective'>
          {/*<FIllField readOnly={true} item={correctiveAction?.old_result?.field} inspection_id={correctiveAction?.inspection_id} />*/}
          {correctiveAction?.old_result?.field?.type === 'radio' ? (
            <div className='corrective__fields'>
              <p>{correctiveAction?.old_result?.field?.label}</p>
              <p className='corrective__fields-label'>
                {
                  correctiveAction?.old_result?.field?.options?.filter(
                    el =>
                      el.value ===
                      correctiveAction?.old_result?.field?.answers[0],
                  )[0]?.label
                }
              </p>
              {correctiveAction?.old_result?.field?.comment_text && (
                <>
                  <p>{t('correctiveActionModal.labels.comment')}</p>
                  <p className='corrective__fields-label'>
                    {correctiveAction?.old_result?.field?.comment_text}
                  </p>
                </>
              )}
              {correctiveAction?.old_result?.field?.comment_files?.length >
                0 && (
                <>
                  <p>{t('correctiveActionModal.labels.file')}</p>
                  <p className='corrective__fields-label'>
                    <span>
                      {
                        correctiveAction?.old_result?.field?.comment_files[0]
                          ?.filename
                      }
                    </span>
                    <img
                      onClick={() => {
                        setViewModalStatus(true);
                        let files =
                          correctiveAction?.old_result?.field?.comment_files?.map(
                            item => item?.url,
                          );
                        setImages(() => files);
                        setActiveImage(files[0]);
                      }}
                      src={
                        correctiveAction?.old_result?.field?.comment_files[0]
                          ?.url
                      }
                      alt='icon'
                    />
                  </p>
                </>
              )}
            </div>
          ) : correctiveAction?.old_result?.field?.type === 'sump_sample' ? (
            <div className='corrective__fields'>
              <p>{correctiveAction?.old_result?.field?.label}</p>
              <p className='corrective__fields-label'>
                {correctiveAction?.old_result?.field?.answers[0]}
              </p>
              {correctiveAction?.old_result?.field?.comment_text && (
                <>
                  <p>{t('correctiveActionModal.labels.comment')}</p>
                  <p className='corrective__fields-label'>
                    {correctiveAction?.old_result?.field?.comment_text}
                  </p>
                </>
              )}
              {correctiveAction?.old_result?.field?.comment_files?.length >
                0 && (
                <>
                  <p>{t('correctiveActionModal.labels.file')}</p>
                  <p className='corrective__fields-label'>
                    <span>
                      {
                        correctiveAction?.old_result?.field?.comment_files[0]
                          ?.filename
                      }
                    </span>
                    <img
                      src={
                        correctiveAction?.old_result?.field?.comment_files[0]
                          ?.url
                      }
                      alt='icon'
                    />
                  </p>
                </>
              )}
            </div>
          ) : correctiveAction?.old_result?.field?.type === 'select' ? (
            <div className='corrective__fields'>
              <p>{correctiveAction?.old_result?.field?.label}</p>
              <p className='corrective__fields-label'>
                {
                  correctiveAction?.old_result?.field?.options?.filter(
                    el =>
                      el.value ===
                      correctiveAction?.old_result?.field?.answers[0],
                  )[0]?.label
                }
              </p>
              {correctiveAction?.old_result?.field?.comment_text && (
                <>
                  <p>{t('correctiveActionModal.labels.comment')}</p>
                  <p className='corrective__fields-label'>
                    {correctiveAction?.old_result?.field?.comment_text}
                  </p>
                </>
              )}
              {correctiveAction?.old_result?.field?.comment_files?.length >
                0 && (
                <>
                  <p>{t('correctiveActionModal.labels.file')}</p>
                  <p className='corrective__fields-label'>
                    <span>
                      {
                        correctiveAction?.old_result?.field?.comment_files[0]
                          ?.filename
                      }
                    </span>
                    <img
                      src={
                        correctiveAction?.old_result?.field?.comment_files[0]
                          ?.url
                      }
                      alt='icon'
                    />
                  </p>
                </>
              )}
            </div>
          ) : correctiveAction?.old_result?.field?.type === 'text' ? (
            <div className='corrective__fields'>
              <p>{correctiveAction?.old_result?.field?.label}</p>
              <p className='corrective__fields-label'>
                {correctiveAction?.old_result?.field?.value}
              </p>
            </div>
          ) : correctiveAction?.old_result?.field?.type === 'textarea' ? (
            <div className='corrective__fields'>
              <p>{correctiveAction?.old_result?.field?.label}</p>
              <p className='corrective__fields-label'>
                {correctiveAction?.old_result?.field?.value}
              </p>
            </div>
          ) : null}
          {(currentTab === 0 || currentTab === 1) && (
            <div className='corrective__fields'>
              <p>{t('correctiveActionModal.labels.createdAt')}</p>
              <p className='corrective__fields-label'>
                {moment
                  .parseZone(correctiveAction?.created_at)
                  .format('MM/DD/YY HH:mm')}
              </p>
              {currentTab === 1 && (
                <>
                  <p>{t('correctiveActionModal.labels.closedAt')}</p>
                  <p className='corrective__fields-label'>
                    {moment
                      .parseZone(correctiveAction?.closed_time)
                      .format('MM/DD/YY HH:mm')}
                  </p>
                </>
              )}
              <p>{t('correctiveActionModal.labels.inspectionDate')}</p>
              <p className='corrective__fields-label'>
                {correctiveAction?.date ? correctiveAction?.date : '---'}
              </p>
              {correctiveAction?.inspection_title !==
                'Fuel Facility Checks' && (
                <>
                  <p>{t('correctiveActionModal.labels.equipmentType')}</p>
                  <p className='corrective__fields-label'>
                    {correctiveAction?.equipment_type_title
                      ? correctiveAction?.equipment_type_title
                      : '---'}
                  </p>
                  <p>{t('correctiveActionModal.labels.equipmentId')}</p>
                  <p className='corrective__fields-label'>
                    {correctiveAction?.equipment_title
                      ? correctiveAction?.equipment_title
                      : '---'}
                  </p>
                </>
              )}
              <>
                <p>{t('correctiveActionModal.labels.equipmentPeriod')}</p>
                <p className='corrective__fields-label'>
                  {correctiveAction?.inspection_period
                    ? correctiveAction?.inspection_period
                    : '---'}
                </p>
              </>
              <p>{t('correctiveActionModal.labels.facility')}</p>
              <p className='corrective__fields-label'>
                {correctiveAction?.facility_title
                  ? correctiveAction?.facility_title
                  : '---'}
              </p>
              {currentTab === 1 && (
                <>
                  <p>{t('correctiveActionModal.labels.closedBy')}</p>
                  <p className='corrective__fields-label'>
                    {correctiveAction?.closed_by_name
                      ? correctiveAction?.closed_by_name
                      : '---'}
                  </p>
                </>
              )}
              <Input
                id='discrepancy'
                name='discrepancy'
                placeholder={t('correctiveActionModal.labels.discrepancy')}
                label={t('correctiveActionModal.labels.discrepancy')}
                type={'text'}
                readOnly={true}
                onChange={handleChange}
                defaultValue={correctiveAction?.discrepancy}
              />
            </div>
          )}

          {correctiveAction?.comments_history &&
            correctiveAction.comments_history.length > 0 && (
              <div className='corrective-actions-modal__section'>
                <div className='remarks-history-container'>
                  <p className='remarks-history__intro'>
                    {t('correctiveActionModal.comments_history.description')}:
                  </p>
                  <div className='remarks-history'>
                    {correctiveAction.comments_history.map((remark, index) => (
                      <div key={index} className='remark-item'>
                        <div className='remark-item__date'>
                          {moment(remark.created_at).format('MM-DD-YY')}
                        </div>
                        <div className='remark-item_wrapper'>
                          <div className='remark-item_des'>Submitted by:</div>
                          <div className='remark-item_val'>
                            {remark.created_by_user || ''}
                          </div>
                        </div>
                        <div className='remark-item__text'>
                          {remark.comment || ''}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

          {correctiveAction?.similar_correctives &&
            correctiveAction?.similar_correctives?.length > 0 && (
              <div className='similar-correctives-section'>
                <p className='similar-correctives-header'>
                  There are [{correctiveAction.similar_correctives.length}]
                  similar corrective actions for this field, select which you
                  want to close together:
                </p>

                <div className='similar-correctives-select-all'>
                  <div className='similar-correctives-item'>
                    <Checkbox
                      label='Select All'
                      checked={isAllSelected}
                      onChange={handleSelectAllSimilar}
                      id='select-all-similar'
                    />
                  </div>
                </div>

                <div className='similar-correctives-list'>
                  {correctiveAction.similar_correctives.map(item => (
                    <div key={item.id} className='similar-correctives-item'>
                      <div className='similar-correctives-item-content'>
                        <div className='similar-correctives-item-date-row'>
                          <div className='similar-correctives-item-date'>
                            {moment(item.created_at).format('MM.DD.YYYY')}
                          </div>
                          <div className='similar-correctives-item-checkbox'>
                            <Checkbox
                              checked={selectedSimilarCorrectives.includes(
                                item.id,
                              )}
                              onChange={() => handleSelectSimilar(item.id)}
                              id={`similar-corrective-${item.id}`}
                            />
                          </div>
                        </div>
                        <div className='similar-correctives-item-text'>
                          {item.discrepancy}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

          <hr style={{margin: '20px 0', opacity: '0.2'}} />
          <h3 className={'corrective__fields-title'}>
            {t('correctiveActionModal.labels.resolutionTitle')}{' '}
          </h3>
          <p className={'corrective__fields-desc'}>
            {t('correctiveActionModal.labels.resolutionDescription')}
          </p>

          <Input
            id='action'
            name='action'
            placeholder={t(
              'correctiveActionModal.labels.correctiveActionPlaceholder',
            )}
            label={t('correctiveActionModal.labels.correctiveAction')}
            type={'text'}
            readOnly={currentTab === 1}
            onChange={handleChange}
            defaultValue={currentTab === 1 ? correctiveAction?.action : ''}
          />
          <Input
            id='repair_time'
            name='repair_time'
            placeholder={t(
              'correctiveActionModal.labels.repairTimePlaceholder',
            )}
            label={t('correctiveActionModal.labels.repairTime')}
            type={'text'}
            readOnly={currentTab === 1}
            onChange={handleChange}
            defaultValue={currentTab === 1 ? correctiveAction?.repair_time : ''}
          />

          {currentTab === 0 ? (
            <>
              <span className='customInput'>
                {correctiveAction?.millipore_required
                  ? t('correctiveActionModal.upload.milliporeTest')
                  : t('correctiveActionModal.upload.file')}
              </span>
              <div className='fillInspection__field-commentFile'>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '5px',
                    overflow: 'auto',
                  }}
                >
                  {image?.preview &&
                    image?.preview?.map((item, index) => (
                      <img
                        onClick={() => clickImage(item)}
                        className='fillInspection__field-galleryPhoto'
                        src={item}
                        key={index}
                        alt='img'
                      />
                    ))}
                </div>
                <label htmlFor='images'>
                  <span>
                    <img src='/assets/icons/camera.svg' alt='camera' />
                  </span>
                  <p>{t('correctiveActionModal.upload.chooseFile')}</p>
                </label>
                <input
                  className='inputFile'
                  id='images'
                  name='images'
                  onChange={handleImage}
                  multiple
                  type='file'
                  accept='image/*'
                />
              </div>
            </>
          ) : (
            correctiveAction?.images?.length > 0 && (
              <>
                <span className='customInput'>
                  {correctiveAction?.millipore_required
                    ? t('correctiveActionModal.upload.milliporeTest')
                    : t('correctiveActionModal.upload.file')}
                </span>
                <div
                  style={{display: 'flex', alignItems: 'center', gap: '5px'}}
                >
                  {correctiveAction?.images?.map((item, index) => (
                    <img
                      className='fillInspection__field-galleryPhoto'
                      src={item}
                      key={index}
                      alt='img'
                    />
                  ))}
                </div>
              </>
            )
          )}
        </div>
        {currentTab === 0 && (
          <div className='modal__content-bottom'>
            <button className='close' onClick={exit}>
              {t('correctiveActionModal.buttons.close')}
            </button>
            <button className='save' onClick={closeAction}>
              {t('correctiveActionModal.buttons.save')}
            </button>
          </div>
        )}
      </div>
      <div className='modal__bg'></div>
    </div>
  );
}
